import { toError } from "@clipboard-health/util-ts";
import { Skeleton } from "@mui/material";
import { APP_V2_USER_EVENTS, useToast } from "@src/appV2/lib";
import { logError } from "@src/appV2/lib/analytics/log";
import { useState } from "react";
import { Document, Page } from "react-pdf";

import { WORK_BADGE_PDF_DEFAULT_SETTINGS } from "../constants/badgePdf";
import { WorkBadgePreviewError } from "./WorkBadgePreviewError";

interface WorkBadgePreviewProps {
  workBadgePdf: {
    pdfKey: string;
    blob: Blob;
  };
  badgeContainerWidth: number;
}

export function WorkBadgePreview(props: WorkBadgePreviewProps) {
  const { workBadgePdf, badgeContainerWidth } = props;

  const [loadError, setLoadError] = useState<boolean>(false);

  const minHeight = badgeContainerWidth / WORK_BADGE_PDF_DEFAULT_SETTINGS.BADGE.ASPECT_RATIO;

  const { showErrorToast } = useToast();

  if (loadError) {
    return <WorkBadgePreviewError />;
  }

  return (
    <Document
      key={workBadgePdf.pdfKey}
      file={workBadgePdf.blob}
      loading={<Skeleton variant="rectangular" height={minHeight} width="100%" />}
      onLoadError={(error) => {
        logError(APP_V2_USER_EVENTS.WORK_BADGE_PREVIEW_LOAD_FAILURE, {
          error: toError(error),
        });
        showErrorToast(
          "Failed to load badge. Please try again. If the problem persists, please contact support."
        );
        setLoadError(true);
      }}
    >
      <Page
        pageNumber={1}
        width={badgeContainerWidth}
        loading={<Skeleton variant="rectangular" height={minHeight} width="100%" />}
      />
    </Document>
  );
}
